import React, { useState } from 'react';
import { useMetadata } from '../../context/MetadataContext'; 
import { useAd } from '../../context/AdContext';
import { useGameState } from '../../context/GameStateContext';
import { useGlobalError } from '../../context/GlobalErrorContext';
import { Search } from 'lucide-react';
import styles from './SoloFind.module.css';


const SoloFind = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { getText } = useMetadata();
  const adContext = useAd();
  const { gameData, findPuzzle} = useGameState();
  const { triggerError } = useGlobalError();

  if (gameData?.state) {
    triggerError('high', 'SoloFind component rendered when puzzle already selected. This indicates a routing/status determination error.');
    return null;
  }

  const handleFindPuzzle = async (e) => {
    findPuzzle();
  };

  return (
    <div className="dataContainer">
      <div className="containerHeader">
        <h2>{getText('solo_mode.find_title')}</h2>
      </div>
      <div className="dataContent">
      <div className="contentGroup">       
       <div className="groupHeader">
        <h3>{getText('solo_mode.how_title')}</h3>
       </div>
        
        <div className="groupDescription">
          {getText('solo_mode.find_description')}
        </div>
      </div>
      </div>
      <div className="actionButtonContainer">
        <button 
          className="iconButton primaryButton"
          onClick={handleFindPuzzle}
          title={getText('common_text.find')}
          aria-label={getText('common_text.find')}
          disabled={loading}
        >
          <Search className="buttonIcon" />
        </button>
      </div>  
        <div className="actionSubText">
          {getText('solo_mode.find_filter')}
        </div>

    </div>
  );
};

export default SoloFind;
